import React, { useContext } from 'react'
import { Moment } from 'moment-timezone'
import TenantDatePicker from '../../TenantDatePicker'
import { LocalizationContext } from '../../contexts'
import { RangeValue } from '../types'

interface DateRangeFilterProps {
  label: string
  value: RangeValue
  onChange: (value: RangeValue) => void
}

const slotProps = { textField: { size: 'small' as const, fullWidth: true } }

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ label, value, onChange }) => {
  const { date_format } = useContext(LocalizationContext)

  return (
    <div>
      <label className="form-label">{label}</label>
      <div className="d-flex gap-2 align-items-center">
        <TenantDatePicker
          value={value.from}
          maxDate={value.to ?? undefined}
          format={date_format}
          slotProps={slotProps}
          onChange={(from: Moment | null) => onChange({ ...value, from })}
        />
        <span className="table-filters__range-separator">-</span>
        <TenantDatePicker
          value={value.to}
          minDate={value.from ?? undefined}
          format={date_format}
          slotProps={slotProps}
          onChange={(to: Moment | null) => onChange({ ...value, to })}
        />
      </div>
    </div>
  )
}

export default DateRangeFilter
